$(document).ready(function() {
    // Function to enable the "Add to Cart" button if any input element with the name "size" has the "checked" attribute
    
    function checkInputsAndEnableButtonOnClick(e, thisForm) {
        // let thisForm;
        // if($(e).hasClass("btn--quick") || $(e).hasClass("product-upsell__btn")){
        //     thisForm = $(".popup-quick-view__form")
        //     console.log("   quickview button is e  ", e)
        // }else{
        //     thisForm = $(document).find("form.product__form")
            if(!thisForm){
                thisForm = $(e).closest("form.product__form")
            }
        // }
        $(thisForm).addClass("initiated")
        const addToCartButton = $(thisForm).find($('.PDP-ATC'))
        const shopPayBtn = $(thisForm).find($('.shopify-payment-button__button div[role="button"]'));
        const sizeInputs = $(thisForm).find('input[name="options[Size]"]');
        const submitButtons = $(thisForm).find('.product__submit__buttons')
        let errorLoaded = $(thisForm).find('.PDP-ERROR-TEXT')

        // Add error message block if it hasn't already been added to this product form
        if(!$(errorLoaded) || $(errorLoaded).length == 0){
            const errorSpan = $('<span class="PDP-ERROR-TEXT aos-init aos-animate"></span>');
            $(errorSpan).insertBefore(submitButtons);
            errorLoaded = $(thisForm).find('.PDP-ERROR-TEXT')
        }
        let atLeastOneChecked = false;
            // console.log('size inputs are?', sizeInputs)
        sizeInputs.each(function() {
            if (this.checked) {
                // console.log('Element is checked:', this);
                atLeastOneChecked = true;
                $(errorLoaded).removeClass("show");
                // debugger
            }
        });

        if (e && atLeastOneChecked ) {
                const transparency = $(thisForm).find(".submit-button--transparency");
                
                if (transparency.length > 0) {
                    transparency.remove();
                } 
        }
        else{
            if($(e).hasClass('submit-button--transparency')){
                if (!$(this).prop('checked')) {
                     $(errorLoaded).addClass('show');
                 }
            }
        }
        addToCartButton.each(function(){
            $(this).prop('disabled', !atLeastOneChecked);
        })
        shopPayBtn.each(function(){
            $(this).prop('aria-disabled="true"', !atLeastOneChecked);
        })
        shopPayBtn.each(function(){
            $(this).prop('aria-disabled="false"', atLeastOneChecked);
        })
        errorLoaded.text('Select a size', !atLeastOneChecked); 
    }

    if(window.location.pathname.includes("products")){
        let thisForm = $(document).find("form.product__form")
        setsClickEvents(thisForm)
        // Initial page load function
        checkInputsAndEnableButtonOnClick(document, thisForm);

        // Prevent the theme from scrolling to the variant image when selecting options.
        // The theme's tall-layout mode calls window.scrollTo() inside its change handler;
        // we intercept in capture phase (fires before their bubble-phase listeners) and
        // temporarily replace window.scrollTo so that one call becomes a no-op.
        document.addEventListener('change', function(e) {
            if (e.target && e.target.hasAttribute('data-single-option-selector')) {
                var orig = window.scrollTo.bind(window);
                window.scrollTo = function() {};
                setTimeout(function() { window.scrollTo = orig; }, 100);
            }
        }, true);
    }

    function handleClickButtons(button){
        const thisBtn = $(button)
        let productID;
        if($(thisBtn).hasClass('product-upsell__btn')){
            productID = $(thisBtn).closest('.product-upsell__holder').attr('data-product-id')

        }else{

            productID = $(thisBtn).closest('.product-grid-item__quick-buy').attr('data-product-id')
        }
        let qvModal;
        let thisForm;
        let counter = 0
        let counter2 = 0
        let checkForQVLoad = setInterval(function(){
            qvModal = $(`div[data-product-id=${productID}]`)
            if($(qvModal).length > 0 || counter > 30){
                let checkFormLoaded = setInterval(function() {
                    if($(thisBtn).hasClass('product-upsell__btn')){
                        thisForm = $(`.product__form[data-product-id=${productID}]`)
                        if(thisForm.hasClass('initiated')){
                            return
                        }
                    }else{
                        thisForm = $(`.popup-quick-view__form[data-product-id=${productID}]`)
                    }
                    if($(thisForm) && $(thisForm).length > 0 || counter2 > 30){
                        const sizeInputs = $(thisForm).find('input[name="options[Size]"]');   
                        sizeInputs.each(function() {
                            if (this.checked) {
                                this.checked = false // Debug: Unchecks any previously checked inputs in previously opened quickview
                            }
                        });
                        setsClickEvents(thisForm)
                        checkInputsAndEnableButtonOnClick(thisBtn, thisForm);
                        clearInterval(checkFormLoaded)
                    }
                    counter2 += 1
                }, 100);
                clearInterval(checkForQVLoad)
            }
            counter += 1
        }, 200)
    } 
    $(".btn--quick").on("click", function(){
        handleClickButtons($(this))
    })
    
    $(".product-upsell__btn").on("click", function(){
        handleClickButtons($(this))
    })
    function setsClickEvents(thisForm){
        // Click events to handle erroring if size not selected
        // Removes transparent div over ATC button if size is selected, allowing ATC to be clickable
        $(thisForm).find(".submit-button--transparency").each(function(){
            $(this).on("click", function(){ 
                checkInputsAndEnableButtonOnClick(this, thisForm)
            })
        }) 
        $(thisForm).find(".radio__button").each(function(){
            $(this).on("click", function(){
                checkInputsAndEnableButtonOnClick(this, thisForm)
            })
        })
        
    }
});

